import {Component, Input, ElementRef, ViewChild, inject, OnInit, TemplateRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgOptimizedImage} from "@angular/common";
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {SupplierSystemsService} from "../../../services/supplier-systems/supplier-systems.service";
import { NzButtonModule } from 'ng-zorro-antd/button';
import {LogosService} from "../../../services/resources/logos.service";
import {switchMap} from "rxjs";
import {HttpEventType, HttpClient} from "@angular/common/http";
import {VerificationStatusPipe} from "../../importer-accounts/importer-accounts.component";
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import {NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCardModule } from 'ng-zorro-antd/card';


@Component({
  selector: 'data-source',
  standalone: true,
  imports: [NgOptimizedImage, NzIconModule, NzTypographyModule, CommonModule, NzButtonModule, VerificationStatusPipe, NzSwitchModule, NzToolTipModule, NzCardModule],
  templateUrl: './data-source.component.html',
  styleUrl: './data-source.component.scss'
})
export class DataSourceComponent implements OnInit {

  @Input() dataSource: any;
  @Input() isDownloadImagePossible: boolean = true;
  @Input() isFooterVisible: boolean = false;

  previewUrl: string | ArrayBuffer | null = null;
  errorMessage: string | null = null;

  notificationService = inject(NzNotificationService)
  logosService = inject(LogosService)

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;


  constructor(private http: HttpClient) {}


  onLogoClick() {
    if(this.isDownloadImagePossible) {
      this.fileInput.nativeElement.click();
    }
  }


  ngOnInit() {

  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    if (file.type !== 'image/png') {
      this.notificationService.error('Error', 'Only PNG images allowed')
      this.fileInput.nativeElement.value = '';
      return;
    }

    const maxSize = 200 * 1024;
    if (file.size > maxSize) {
      this.notificationService.error('Error', 'max size: 200KB')
      this.fileInput.nativeElement.value = '';
      console.log(this.errorMessage);
      return;
    }

    this.errorMessage = null;

    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result;
    };
    reader.readAsDataURL(file);

    const formData = new FormData();
    formData.append('file', file);


    this.logosService.getSupplierSystemLogoUrl(file.name).pipe(
        switchMap((res: any) => {
          return this.logosService.uploadLogo(res.url, res.fields, file);
        })
      )
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            // const percentDone = Math.round((100 * event.loaded) / event.total);
            // console.log(`Upload progress: ${percentDone}%`);
          } else if (event.type === HttpEventType.Response) {
            this.notificationService.success("Success", "Image uploaded successfully");
          }
        },
        error: (err) => {
          console.error(err);
          this.notificationService.error("Error", "Upload failed");
        }
      });

  }

  deleteDataSourceRequest(){

  }

}
